module.exports = __webpack_public_path__ + "media/images/ui__textArrowUp-81453456e6b4ece4e7cc50a52b701818.png";